import { Box, Typography, IconButton, Modal } from '@mui/material'
import { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'
import { CollapsibleSection } from '../CollapsibleSection'
import styles from './styles.module.scss'

export const DocumentImages = ({ vendorData }) => {
  const { t } = useTranslation(['common'])
  const [selectedImage, setSelectedImage] = useState(null)

  if (!vendorData || !vendorData.id_verification) {
    return null
  }

  const idVerification = vendorData.id_verification

  const hasImages = idVerification.front_image || idVerification.back_image || idVerification.portrait_image
  const hasFullImages = idVerification.full_front_image || idVerification.full_back_image
  const hasVideos = idVerification.front_video || idVerification.back_video

  if (!hasImages && !hasFullImages && !hasVideos) {
    return null
  }

  const handleImageError = (e, imageName) => {
    console.error(`[DocumentImages] Error loading ${imageName}:`, e.target.src)
    // Show a fallback message
    e.target.style.display = 'none'
    const fallbackDiv = document.createElement('div')
    fallbackDiv.style.cssText = 'padding: 2rem; background-color: #f5f5f5; border-radius: 8px; text-align: center; color: #666;'
    fallbackDiv.innerHTML = `
      <p style="margin: 0; font-size: 14px;">No se pudieron cargar las imágenes</p>
      <p style="margin: 0.5rem 0 0 0; font-size: 12px;">Recargue la página para intentar nuevamente</p>
    `
    e.target.parentNode.appendChild(fallbackDiv)
  }

  const handleImageLoad = (imageName) => {
    
  }

  return (
    <>
      <CollapsibleSection title={t('common:documentImagesVideos')}>

        {hasImages && (
          <Box className={styles.section}>
            <Typography variant="h6" mb={2}>
              {t('common:documentImages')}
            </Typography>
            <Box className={styles.imagesGrid}>
              {idVerification.front_image && (
                <Box className={styles.imageBox} onClick={() => setSelectedImage(idVerification.front_image)}>
                  <Box className={styles.imageHeader}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {t('common:frontImage')}
                    </Typography>
                  </Box>
                  <Box className={styles.imageWrapper}>
                    <img
                      src={idVerification.front_image}
                      alt="Front"
                      className={styles.documentImage}
                      onError={(e) => handleImageError(e, 'front_image')}
                      onLoad={() => handleImageLoad('front_image')}
                    />
                  </Box>
                </Box>
              )}
              {idVerification.back_image && (
                <Box className={styles.imageBox} onClick={() => setSelectedImage(idVerification.back_image)}>
                  <Box className={styles.imageHeader}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {t('common:backImage')}
                    </Typography>
                  </Box>
                  <Box className={styles.imageWrapper}>
                    <img
                      src={idVerification.back_image}
                      alt="Back"
                      className={styles.documentImage}
                      onError={(e) => handleImageError(e, 'back_image')}
                      onLoad={() => handleImageLoad('back_image')}
                    />
                  </Box>
                </Box>
              )}
              {idVerification.portrait_image && (
                <Box className={styles.imageBox} onClick={() => setSelectedImage(idVerification.portrait_image)}>
                  <Box className={styles.imageHeader}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {t('common:portraitImage')}
                    </Typography>
                  </Box>
                  <Box className={styles.imageWrapper}>
                    <img
                      src={idVerification.portrait_image}
                      alt="Portrait"
                      className={styles.documentImage}
                      onError={(e) => handleImageError(e, 'portrait_image')}
                      onLoad={() => handleImageLoad('portrait_image')}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        )}

        {hasFullImages && (
          <Box className={styles.section}>
            <Typography variant="h6" mb={2}>
              {t('common:fullDocumentImages')}
            </Typography>
            <Box className={styles.imagesGrid}>
              {idVerification.full_front_image && (
                <Box className={styles.imageBox} onClick={() => setSelectedImage(idVerification.full_front_image)}>
                  <Box className={styles.imageHeader}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {t('common:fullFrontImage')}
                    </Typography>
                  </Box>
                  <Box className={styles.imageWrapper}>
                    <img
                      src={idVerification.full_front_image}
                      alt="Full Front"
                      className={styles.documentImage}
                      onError={(e) => handleImageError(e, 'full_front_image')}
                      onLoad={() => handleImageLoad('full_front_image')}
                    />
                  </Box>
                </Box>
              )}
              {idVerification.full_back_image && (
                <Box className={styles.imageBox} onClick={() => setSelectedImage(idVerification.full_back_image)}>
                  <Box className={styles.imageHeader}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {t('common:fullBackImage')}
                    </Typography>
                  </Box>
                  <Box className={styles.imageWrapper}>
                    <img
                      src={idVerification.full_back_image}
                      alt="Full Back"
                      className={styles.documentImage}
                      onError={(e) => handleImageError(e, 'full_back_image')}
                      onLoad={() => handleImageLoad('full_back_image')}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        )}

        {hasVideos && (
          <Box className={styles.section}>
            <Typography variant="h6" mb={2}>
              {t('common:documentCaptureVideos')}
            </Typography>
            <Box className={styles.videosGrid}>
              {idVerification.front_video && (
                <Box className={styles.videoBox}>
                  <Box className={styles.videoHeader}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {t('common:frontVideo')}
                    </Typography>
                  </Box>
                  <Box className={styles.videoWrapper}>
                    <video controls className={styles.documentVideo}>
                      <source src={idVerification.front_video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </Box>
                </Box>
              )}
              {idVerification.back_video && (
                <Box className={styles.videoBox}>
                  <Box className={styles.videoHeader}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {t('common:backVideo')}
                    </Typography>
                  </Box>
                  <Box className={styles.videoWrapper}>
                    <video controls className={styles.documentVideo}>
                      <source src={idVerification.back_video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        )}
      </CollapsibleSection>

      {/* Lightbox Modal */}
      <Modal
        open={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        sx={{ zIndex: 99999 }}
      >
        <Box className={styles.modal} onClick={() => setSelectedImage(null)}>
          <Box className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <IconButton className={styles.closeButton} onClick={() => setSelectedImage(null)}>
              <CloseIcon />
            </IconButton>
            <img src={selectedImage} alt="Document" className={styles.modalImage} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
